module.exports = __webpack_public_path__ + "img/solanalocals.ab501cfb.webp";